var addScrollToSiblingElement = function(elem) {
  if(!elem.previousElementSibling || !elem.nextElementSibling ) {
    //If there is no sibling element, this plugin will not work
    return false;
  }
  if( elem.scrollHeight == elem.clientHeight ) {
    elem.previousElementSibling.className = '';
    elem.nextElementSibling.className = '';
  }
  else if(elem.scrollTop < 2){
    elem.previousElementSibling.className = '';
    elem.nextElementSibling.className = 'scroll-down';
  }
  else if(elem.clientHeight + elem.scrollTop > elem.scrollHeight  - 3){
    elem.previousElementSibling.className = 'scroll-up';
    elem.nextElementSibling.className = '';
  } else {
    elem.previousElementSibling.className = 'scroll-up';
    elem.nextElementSibling.className = 'scroll-down';
  }  
  window.onresize = function() {
    if( elem && (elem.scrollHeight == elem.clientHeight)) {
      elem.previousElementSibling.className = '';
      elem.nextElementSibling.className = '';
    }
  }
}
export default addScrollToSiblingElement;